import { connect } from 'react-redux'
import journalRowComponent from '../../components/openforwork/journalRow.component'
import {
  getJournalEdit,
  warnDeleteJournal,
  closeWarnDeleteJournal,
  deleteJournal,
  cancelJournalEdit
} from '../../actions'

const mapStateToProps = (state) => {
  return {
    state,
    warnDelateJournal: state.workShiftUser.warnDelateJournal,
    delete_journal_id: state.workShiftUser.delete_journal_id,
    isEditJournal: state.workShiftUser.isEditJournal,
    updateJournalSnackbar: state.workShiftUser.updateJournalSnackbar,
    updateJournalFailSnackbar: state.workShiftUser.updateJournalFailSnackbar
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getJournalEdit: (id) => dispatch(getJournalEdit(id)),
    warnDeleteJournal: (id) => dispatch(warnDeleteJournal(id)),
    deleteJournal: (id) => dispatch(deleteJournal(id)),
    closeWarnDeleteJournal: () => dispatch(closeWarnDeleteJournal()),
    cancelJournalEdit: () => dispatch(cancelJournalEdit())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const JournalRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(journalRowComponent)

export default JournalRowContainer
